import { render, staticRenderFns } from "./OtherOfficeMessage.vue?vue&type=template&id=671f45c4&scoped=true&lang=pug"
import script from "./OtherOfficeMessage.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeMessage.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeMessage.vue?vue&type=style&index=0&id=671f45c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f45c4",
  null
  
)

export default component.exports